import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';

const GridTableStencilsCanvas = ({ width = 400, height = 400, rows = 5, cols = 5, onClose }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [convertedText, setConvertedText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const drawColor = 'black'; // Set the drawing color

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas before drawing the grid
    ctx.clearRect(0, 0, width, height);

    // Set canvas background color
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, width, height);
    
    // Draw the grid
    const cellWidth = width / cols;
    const cellHeight = height / rows;

    ctx.strokeStyle =  '#ADD8E6';  // Light gray grid lines
    ctx.lineWidth = 1;

    for (let i = 0; i <= cols; i++) {
      const x = i * cellWidth;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
      ctx.stroke();
    }

    for (let i = 0; i <= rows; i++) {
      const y = i * cellHeight;
      ctx.beginPath();
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
    }

    // Set text color and font
  ctx.fillStyle = 'gray';
  ctx.font = '16px Arial'; // Set font size and type

  let number = 1;
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const x = (col + 0.5) * cellWidth;
      const y = (row + 0.5) * cellHeight;
      ctx.textAlign = 'center'; // Center text horizontally
      ctx.textBaseline = 'middle'; // Center text vertically
      ctx.fillText((row+1)*(col+1), x, y);
      number++;
      if (number > 100) break; 
    }
    if (number > 100) break; 
  }
  }, [width, height, rows, cols]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const startDrawing = (offsetX, offsetY) => {
      ctx.strokeStyle = drawColor;  // Set stroke color
      ctx.lineWidth = 2;  // Set line width for drawing
      ctx.beginPath();
      ctx.moveTo(offsetX, offsetY);
      setIsDrawing(true);
    };

    const draw = (offsetX, offsetY) => {
      if (!isDrawing) return;
      ctx.lineTo(offsetX, offsetY);
      ctx.stroke();
    };

    const endDrawing = () => {
      if (isDrawing) {
        setIsDrawing(false);
        ctx.beginPath(); // Reset the path
      }
    };

    const handleMouseDown = (e) => {
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      startDrawing(offsetX, offsetY);
    };

    const handleMouseMove = (e) => {
      if (!isDrawing) return;
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;
      draw(offsetX, offsetY);
    };

    const handleTouchStart = (e) => {
      e.preventDefault();
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      const offsetY = e.touches[0].clientY - rect.top;
      startDrawing(offsetX, offsetY);
    };

    const handleTouchMove = (e) => {
      e.preventDefault();
      if (!isDrawing) return;
      const rect = canvas.getBoundingClientRect();
      const offsetX = e.touches[0].clientX - rect.left;
      const offsetY = e.touches[0].clientY - rect.top;
      draw(offsetX, offsetY);
    };

    const handleMouseUp = endDrawing;
    const handleMouseOut = endDrawing;
    const handleTouchEnd = endDrawing;

    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mousemove', handleMouseMove);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('mouseout', handleMouseOut);
    canvas.addEventListener('touchstart', handleTouchStart);
    canvas.addEventListener('touchmove', handleTouchMove);
    canvas.addEventListener('touchend', handleTouchEnd);

    return () => {
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mousemove', handleMouseMove);
      canvas.removeEventListener('mouseup', handleMouseUp);
      canvas.removeEventListener('mouseout', handleMouseOut);
      canvas.removeEventListener('touchstart', handleTouchStart);
      canvas.removeEventListener('touchmove', handleTouchMove);
      canvas.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDrawing, drawColor]);

  const handleUploadImage = async () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const dataURL = canvas.toDataURL('image/png');
      const response = await fetch(dataURL);
      const blob = await response.blob();
      const formData = new FormData();
      formData.append('image', blob, 'canvas-image.png');
      await axios.post('http://localhost:5000/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      alert('Image uploaded successfully!');
    }
  };

  const handleConvertToText = () => {
    setLoading(true);
    const canvas = canvasRef.current;
    const imageDataURL = canvas.toDataURL();

    fetch('https://api.ocr.space/parse/image', {
      method: 'POST',
      body: JSON.stringify({ base64Image: imageDataURL }),
      headers: {
        'Content-Type': 'application/json',
        'apikey': 'K81755459088957', // Replace with your OCR API key
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.IsErroredOnProcessing) {
          setError(data.ErrorMessage);
          setConvertedText('');
        } else {
          setConvertedText(data.ParsedResults[0]?.ParsedText || 'No text found');
          setError('');
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setError('An error occurred while processing the image.');
        setConvertedText('');
        setLoading(false);
      });
  };

  const handleSaveText = async () => {
    try {
      await axios.post('http://localhost:5000/save-text', { text: convertedText });
      alert('Text extracted and saved successfully!');
    } catch (error) {
      console.error('Error saving text:', error);
      alert('Failed to save text.');
    }
  };

  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, width, height);
  };

  return (
    <div style={{ marginTop: '250px', position: 'relative' }}>
      <canvas
        ref={canvasRef}
        width={width}  // Adjust this width as needed
        height={height} // Adjust this height as needed
        style={{ 
          border: '1px solid #ccc', 
          backgroundColor: 'white', 
          display: 'block', // Ensure the canvas is not stretched vertically
          margin: '0 auto' // Center the canvas horizontally if needed
        }}
      />
      <div className='flex flex-row'>
        <button onClick={clearCanvas}>Clear</button>
        <button onClick={handleUploadImage}>Upload Image</button>
        <button onClick={handleConvertToText}>Extract Text</button>
      </div>
      {/* Display Converted Text */}
      <div style={{ marginTop: '10px', marginLeft: '10px' }}>
        <h2>Converted Text (Editable):</h2>
        <textarea
          value={convertedText}
          onChange={(e) => setConvertedText(e.target.value)}
          className='text-black bg-white'
          style={{ maxWidth: '100%', height: '200px', fontSize: '12px' }}
        />
      </div>
      <div className='flex flex-row'>
        <button onClick={handleSaveText}>Save Text</button>
        <button onClick={onClose}>Close</button>
      </div>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default GridTableStencilsCanvas;
